import React from 'react';
import { Button } from 'reactstrap';
import { useAuth0, RedirectLoginOptions } from '@auth0/auth0-react';
import styles from './styles';

export function LoginForm() {
  const { loginWithRedirect } = useAuth0();

  const loginParams: RedirectLoginOptions = {
    authorizationParams: {
      prompt: 'select_account'
    }
  };

  return (
    <>
      <div css={styles}>
        <Button block color="primary" size="lg" onClick={() => loginWithRedirect(loginParams)}>
          Continue to Login
        </Button>
      </div>
    </>
  );
}
